// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"aea7f65a","488":"97704191","977":"15de5d99"}[chunkId] + ".chunk.js";
};